import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs'
import { AppState } from '../../../reducers';

import * as model from "../../../models";

@Component({
	selector: 'shopping-cart-header-overview',
	templateUrl: "./shopping-cart-header-overview.html",
	styles: [require("./shopping-cart-header-overview.scss")]
})
export class ShoppingCartHeaderOverview {

	private numberOfItemsInShoppingCart$: Observable<number>

	constructor(
		private store: Store<AppState>
	) { }

	ngOnInit() {
		this.numberOfItemsInShoppingCart$ = this.store.select("shoppingCart", "shoppingCart")
			.map(shoppingCart => shoppingCart ? shoppingCart : { ticketItems: [] })
			.map(shoppingCart => shoppingCart.ticketItems.length)
	}

}



// WEBPACK FOOTER //
// ./src/app/components/header-components/shopping-cart-header-overview/shopping-cart-header-overview.component.ts